import { Affix } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import WhiteKeyIcon from 'assets/Icons/WhiteKeyIcon';
import clsx from 'clsx';
import * as cookie from 'cookie';
import { AnimatePresence } from 'framer-motion';
import { GetServerSideProps } from 'next';
import { Montserrat } from 'next/font/google';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import Script from 'next/script';
import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { twMerge } from 'tailwind-merge';

const montserrat = Montserrat({
  subsets: ['latin'],
  display: 'swap',
});

import { useSessionTracking } from '@/hooks/useSessionTracking';

import Banner from '@/components/Global/Banner';

import { getGlobalCountry } from '@/atoms/countryState';
import { detectCountry, getActiveCountries } from '@/services/globalCountry';
import { checkIsPurchased } from '@/services/ReviewLandingPage';
import {
  productAccessCheckSSR,
  productAccessEnroll,
} from '@/services/Subscribe';
import { getUserProfileDirect } from '@/services/user';
import { setEventContext } from '@/utils/eventContext';
import { EventV2 } from '@/utils/Events/events';
import {
  hasPreviouslySubscribed,
  isPlatformSubscriptionActive,
  isSubscriptionActive,
} from '@/utils/index';
import { IProduct } from '@/utils/interfaces/Product';
import { IProductAccessCheck } from '@/utils/interfaces/Subscription';
import { formatPrice } from '@/utils/Product';
import { removeTrailingSlash } from '@/utils/removeTrailingSlash';

import { authModalControl, tokenUpdate } from '../../../atoms/authModalControl';
import { dynamicTrackingParamsState } from '../../../atoms/dynamicTrackingParams';
import { localUserID, user } from '../../../atoms/user';
import AuthorDetailsSection from '../../../components/BookLandingPageComp/AuthorDeatils';
import BookDescription from '../../../components/BookLandingPageComp/BookDescription';
import CurriculumSection from '../../../components/BookLandingPageComp/CurriculumSection';
import HeroSection from '../../../components/BookLandingPageComp/HeroSection';
import IframeLandingPage from '../../../components/BookLandingPageComp/IframeLandingPage';
import RecommendedAndOverViewSection from '../../../components/BookLandingPageComp/RecommendedAndOverViewSection';
import RecommendedBooksSection from '../../../components/BookLandingPageComp/RecommendedBooksSection';
import ReviewsLandingPage from '../../../components/BookLandingPageComp/ReviewsLandingPage';
import SlidBookContainer from '../../../components/BookLandingPageComp/SlidBookContainer';
import SneakPeekSection from '../../../components/BookLandingPageComp/SneakPeekSection';
import Products from '../../../components/ProjectPage/Products';
import ButtonDefault, {
  ButtonVariants,
} from '../../../components/shared/basic/button';
import Section from '../../../components/shared/basic/section';
import { ShouldRender } from '../../../components/shared/basic/ShouldRender';
import { formateErrorObject } from '../../../components/shared/formateErrorObject';
import { getLoginToken } from '../../../components/shared/getToken';
import {
  extractAuthorDetailsData,
  extractCurriculumLandingPageData,
  extractHeroSectionData,
  extractIBookDescriptionData,
  extractIframeData,
  extractRecommendedAndOverViewSectionData,
  extractSlidBookContainerData,
  extractSneakPeekData,
} from '../../../components/shared/LandingPageHelper';
import CustomLoader from '../../../components/shared/Loading';
import { notify } from '../../../components/shared/notify';
import { Endpoints } from '../../../network';
import {
  addCouponCode,
  addToCart,
  addToRecentlyViewed,
} from '../../../services/Cart';
import {
  getBooDataByIdSSR,
  getBookLandingPageData,
  getBookLandingPageDataSSR,
  getLandingPageSeoSSR,
  getProductDataSSR,
} from '../../../services/LandingPage';
import { getBookBySlug } from '../../../services/Library/Books';
import { addToRecentlyViewedProduct } from '../../../services/Library/RecentlyViewed';
import { getAuthorProfileById } from '../../../services/School';
import { AddToCartProps } from '../../../utils/interfaces/cart';
import {
  IAuthorDetails,
  IAuthorDetailsList,
  IBookDescription,
  IBookLandingPage,
  ICurriculumLandingPageData,
  IHeroSectionLandingPage,
  IIframeLandingPage,
  IRecommendedAndOverViewSection,
  ISlidBook,
  ISneakPeek,
} from '../../../utils/interfaces/landingPage';
import { IBookDetails } from '../../../utils/interfaces/Products/books';
import { User } from '../../../utils/interfaces/User';

interface Props {
  metaData: {
    title: string;
    description: string;
    author: string;
    keywords: string;
    image: string;
    openGraph: {
      title: string;
      description: string;
      image: string;
    };
    categories?: [
      {
        _id: string;
        name: string;
      },
    ];
    canonicalUrl?: string;
    slug: string;
    price: number;
    reviews: any[];
    ratingValue: number;
    reviewCount: number;
  } | null;
  canonicalUrlPageUrl?: string;
  digitalCopyCountryData?: any;
  hardCopyCountryData?: any;
  isPurchased: boolean;
  lastPageRead: number | null;
  productAccessCheckData: IProductAccessCheck | null;
  landingPageData: any | null;
  ecomProductData?: IProduct | null;
}

export interface IAuthorInterface {
  follower_count: string;
  user_name: string;
  is_followed?: boolean;
  is_verified?: boolean;
}

export const generateUrlForImage = (
  baseUrl: string,
  endpoint: string,
  id: string,
): string => {
  const encodedId = encodeURIComponent(id);
  const url = `${baseUrl}${endpoint}${encodedId}`;
  return url;
};

const BookDetailsPage: React.FC<Props> = ({
  metaData,
  canonicalUrlPageUrl,
  digitalCopyCountryData,
  hardCopyCountryData,
  isPurchased,
  lastPageRead,
  productAccessCheckData,
  landingPageData,
  ecomProductData,
}) => {

  console.log({ ecomProductData })





  const [bookLandingDetails, setBookLandingDetails] =
    useState<IBookLandingPage>();
  const [loading, setLoading] = useState(false);

  const [loadingAddToCart, setLoadingAddToCart] = useState({
    value: false,
    id: 0,
  });

  const [token, setToken] = useState('');
  const [offset, setOffset] = useState<number>(0);
  const [isTokenChanged, setIsTokenChanged] = useRecoilState(tokenUpdate);
  const [correctedSlug, setCorrectedSlug] = useState<string>();
  const [authorsData, setAuthorsData] = useState<
    IAuthorInterface | IAuthorInterface[]
  >();
  const [bookDetails, setBooksDetails] = useState<IBookDetails>();
  const [, setVisible] = useRecoilState(authModalControl);
  const setDynamicTrackingParams = useSetRecoilState(dynamicTrackingParamsState);
  const [lastFetchedBookId, setLastFetchedBookId] = useState<string | null>(
    null,
  );

  const [purchasedData, setPurchasedData] = useState<{
    hardProduct: {
      purchased: boolean;
    };
    softProduct: {
      purchased: boolean;
    };
  }>({
    hardProduct: {
      purchased: false,
    },
    softProduct: {
      purchased: false,
    },
  });

  const router = useRouter();
  const screens = useBreakpoint();
  const localUserId = useRecoilValue(localUserID);
  const [userDataState, setUserDataState] = useRecoilState<User | undefined>(user);
  const userData: User | undefined = userDataState;

  const hardCorporatePrice = useMemo(() => {
    const unitPrice =
      ecomProductData?.organization_pricing?.discounted_price ??
      ecomProductData?.i18n_attributes?.unit_price ??
      ecomProductData?.main_price ??
      1790;
    const regularPrice =
      ecomProductData?.organization_pricing?.original_price ??
      ecomProductData?.i18n_attributes?.regular_price ??
      ecomProductData?.stroked_price ??
      3990;
    return {
      unit_price: unitPrice,
      regular_price: regularPrice,
    };
  }, [ecomProductData]);

  const digitalCorporatePrice = useMemo(() => {
    const unitPrice =
      ecomProductData?.digital_pair?.organization_pricing?.discounted_price ??
      ecomProductData?.digital_pair?.i18n_attributes?.unit_price ??
      ecomProductData?.digital_pair?.main_price ??
      990;
    const regularPrice =
      ecomProductData?.digital_pair?.organization_pricing?.original_price ??
      ecomProductData?.digital_pair?.i18n_attributes?.regular_price ??
      ecomProductData?.digital_pair?.stroked_price ??
      1990;
    return {
      unit_price: unitPrice,
      regular_price: regularPrice,
    };
  }, [ecomProductData]);

  const isOrgMember = Boolean(
    userData?.organization &&
    (userData.organization.role === 'member' ||
      userData.organization.role === 'admin'),
  );

  useEffect(() => {
    if (!userData) {
      getUserProfileDirect()
        .then((res) => {
          if (res?.data) {
            setUserDataState(res.data);
          }
        })
        .catch(() => { });
    }
  }, [userData]);

  const { bookId, swp, short } = router.query;

  const isPreOrderAvailable = useMemo(() => {
    return (
      hardCopyCountryData?.is_preorder &&
      hardCopyCountryData?.is_available !== null
    );
  }, [hardCopyCountryData]);

  const claimHandle = (productId: number) => {
    router.push(`/subscription-checkout?productId=${productId}`);
  };

  const checkIsPurchasedHandle = async () => {
    try {
      if (!bookLandingDetails) return;

      const hard = await checkIsPurchased(
        bookLandingDetails?.hardCoverProductId?.toString(),
      );
      setPurchasedData((prevState) => ({
        ...prevState,
        hardProduct: {
          purchased: hard,
        },
      }));
      const soft = await checkIsPurchased(
        bookLandingDetails?.digitalProductId.toString(),
      );
      setPurchasedData((prevState) => ({
        ...prevState,
        softProduct: {
          purchased: soft,
        },
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const getBookDetailsById = async (bookId: string) => {
    try {
      setLoading(true);

      let data = landingPageData;

      if (!data) {
        const response = await getBookLandingPageData(bookId);
        data = response?.data;
      }

      if (data?.correctedSlug) {
        setCorrectedSlug(data.correctedSlug);
      }

      setBookLandingDetails({
        ...data?.form,
        bookType: data?.bookType,
        categories: data?.categories?.map((category: any) => ({
          categoryId: category._id,
          name: category.name,
        })),
      });

      if (data?.bookType === 'short' && short !== 'true') {
        router.push(`${router.asPath.split('?')[0]}?short=true`, undefined, {
          shallow: true,
        });
      }
    } catch (error: any) {
      console.error('API call error:', error);

      if (error?.response?.status === 404) {
        router.push('/books');
      }
    } finally {
      setLoading(false);
    }
  };

  const getBookDetailsByIdSwp = async (bookId: string, userId?: string) => {
    try {
      setLoading(true);

      const response = await getBookBySlug(bookId, userId && userId);

      const formateData = {
        authorName: response?.authors?.[0],
        bookName: response?.title,
        desc: response?.description,
        lang: 'English',
        type: 'Book',
        _id: response?._id,
        authorAvatar: generateUrlForImage(
          `${process.env.NEXT_PUBLIC_API_READER_URL}`,
          `${Endpoints.getAuthorAvatar}/`,
          `${response?.author_list?.[0]?._id}`,
        ),
        totalPages: response?.totalPages,
        bookLSample: response?._id,
        bookType: response?.type,
        isSubscribed: response?.subscribe?.subscribed || false,
        image: generateUrlForImage(
          `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
          `${Endpoints.getCoverImagesForBooks}/`,
          `${response?._id}`,
        ),
      };
      setBooksDetails(formateData);
    } catch (error) {
      console.error('API call error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const updateOffset = () => {
      const containerHeight =
        document.querySelector('.slid-book-container')?.clientHeight || 0;
      const screenHeight = window.innerHeight;
      setOffset((screenHeight - containerHeight) / 15);
    };

    updateOffset();

    window.addEventListener('resize', updateOffset);

    return () => {
      window.removeEventListener('resize', updateOffset);
    };
  }, [bookId]);

  useEffect(() => {
    if (bookId && userData) {
      if (swp === 'false') {
        getBookDetailsByIdSwp(bookId as string, userData && userData?.zl_uid);
      }
    }
  }, [userData, bookId]);

  useEffect(() => {
    if (bookId && bookId !== lastFetchedBookId) {
      if (swp === 'false') {
        getBookDetailsByIdSwp(bookId as string);
      } else {
        getBookDetailsById(bookId as string);
      }

      setLastFetchedBookId(bookId as string);
    }
  }, [bookId, userData, token, short]);

  const fetchData = async () => {
    try {
      const token = await getLoginToken();
      setToken(token as string);
    } catch (error) {
      console.error('Error fetching token:', error);
    }
  };

  useEffect(() => {
    fetchData();
    if (isTokenChanged) {
      setIsTokenChanged(false);
    }
  }, [isTokenChanged]);

  useEffect(() => {
    if (ecomProductData?.display_name) {
      setDynamicTrackingParams({ source_name: ecomProductData.display_name });
      setEventContext({ source_name: ecomProductData?.display_name });
    }
  }, [ecomProductData?.display_name, setDynamicTrackingParams]);

  useEffect(() => {
    if (landingPageData?.categories?.[0]?.name) {
      setEventContext({ product_category: landingPageData?.categories?.[0]?.name });
    }
  }, [landingPageData?.categories?.[0]?.name])

  useEffect(() => {
    const baseSlug = `/books/${bookLandingDetails?.productSlug}-${bookLandingDetails?.readersProductId}`;
    const queryParams = short === 'true' ? '?short=true' : '';
    const formattedSlug = `${baseSlug}${queryParams}`;

    if (
      correctedSlug &&
      bookLandingDetails?.readersProductId &&
      (router.pathname?.split('?')[0] || '') !== baseSlug
    ) {
      router.replace(formattedSlug, undefined, { shallow: true });
    }
  }, [correctedSlug, bookLandingDetails, short]);

  useEffect(() => {
    checkIsPurchasedHandle();
  }, [bookLandingDetails]);

  useEffect(() => {
    if (bookLandingDetails?.readersProductId) {
      addToRecentlyViewedProduct(
        bookLandingDetails.readersProductId,
        'book',
        userData?.zl_uid,
      );
    }
  }, [bookLandingDetails?.readersProductId, userData?.zl_uid]);

  const keyCount = useMemo(() => {
    return (
      userData?.features?.reduce(
        (sum, i) => sum + (i?.available_quantity || 0),
        0,
      ) || 0
    );
  }, [userData]);

  const handleApplyCoupon = async (coupon: string) => {
    try {
      await addCouponCode(coupon as string);
    } catch (error: any) {
      if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
        console.error('Error initializing messaging:', error);
      }
    }
  };

  const handleAddDataToCart = async (
    payload: AddToCartProps,
    type: 'hardCopy' | 'digitalCopy',
    isBuyNow?: boolean,
  ) => {
    try {
      setLoadingAddToCart({ value: true, id: payload.id });

      const data = await addToCart(payload);
      addToRecentlyViewed(payload.id, userData?.zl_uid);
      const isPaperBack =
        landingPageData?.bookType === 'paperBack' ||
        bookLandingDetails?.bookType === 'paperBack';
      notify(
        isPaperBack
          ? `${slidBookContainerData?.bookName} added to cart successfully!`
          : `${slidBookContainerData?.bookName} ${type === 'hardCopy' ? 'Hard Copy' : 'Digital Copy'}  added to cart successfully!`,
        'success',
      );
      if (isBuyNow) {
        await handleApplyCoupon(
          hardCopyCountryData?.preorder_coupon_code || '',
        );
        router.push(
          `${process.env.NEXT_PUBLIC_CHECKOUT_ROUTE || '/checkout'}?cartId=${data?.data?.cart_id}&pre`,
        );
      } else {
        router.push(`/cart/`);
      }
    } catch (error: any) {
      const message = formateErrorObject(error);
      notify(message, 'error');
    } finally {
      setLoadingAddToCart({ value: false, id: payload.id });
    }
  };

  const heroSectionData: IHeroSectionLandingPage | undefined =
    bookLandingDetails ? extractHeroSectionData(bookLandingDetails) : undefined;

  const slidBookContainerData: ISlidBook | undefined = bookLandingDetails
    ? extractSlidBookContainerData(bookLandingDetails)
    : undefined;

  const bookDescriptionData: IBookDescription | undefined = bookLandingDetails
    ? extractIBookDescriptionData(bookLandingDetails)
    : undefined;

  const recommendedAndOverViewSectionData:
    | IRecommendedAndOverViewSection
    | undefined = bookLandingDetails
      ? extractRecommendedAndOverViewSectionData(bookLandingDetails)
      : undefined;

  const curriculumLandingPageData: ICurriculumLandingPageData | undefined =
    bookLandingDetails
      ? extractCurriculumLandingPageData(bookLandingDetails)
      : undefined;

  const sneakPeekData: ISneakPeek | undefined = bookLandingDetails
    ? extractSneakPeekData(bookLandingDetails)
    : undefined;

  const authorDetailsData: IAuthorDetails | IAuthorDetailsList[] | undefined =
    bookLandingDetails?.isMultipleAuthors
      ? bookLandingDetails?.authorsList
      : bookLandingDetails
        ? extractAuthorDetailsData(bookLandingDetails)
        : undefined;

  const iframeData: IIframeLandingPage | undefined = bookLandingDetails
    ? extractIframeData(bookLandingDetails)
    : undefined;

  const handleGetAuthorProfileById = async (zl_uid: string) => {
    try {
      const data = await getAuthorProfileById({ zl_uid });
      return {
        user_name: data?.data?.profile_data?.user_name,
        follower_count: data?.data?.follower_count,
        is_followed: data?.data?.is_followed,
        is_verified: data?.data?.is_verified,
      };
    } catch (error: any) {
      return null;
    }
  };

  const fetchAuthorData = async () => {
    if (
      heroSectionData?.isMultipleAuthors &&
      Array.isArray(heroSectionData?.authorsList)
    ) {
      const results = await Promise.all(
        heroSectionData.authorsList.map(
          (author) =>
            author.authorZlUid &&
            handleGetAuthorProfileById(author.authorZlUid),
        ),
      );
      const filtered = results.filter(Boolean) as IAuthorInterface[];
      setAuthorsData(filtered);
    } else if (heroSectionData?.authorZlUid) {
      const singleAuthor = await handleGetAuthorProfileById(
        heroSectionData.authorZlUid,
      );
      if (singleAuthor) {
        setAuthorsData(singleAuthor);
      }
    }
  };

  useEffect(() => {
    fetchAuthorData();
  }, [heroSectionData?.isMultipleAuthors, heroSectionData?.authorZlUid]);


  useEffect(() => {
    const currentUrl = window.location.href;

    const utmData: Record<string, string> = {};
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        utmData[key] = value;
      }
    });
    const zebra_selected_country = JSON.parse(localStorage.getItem('zebra_selected_country') as string)?.value?.country;

    const run = async () => {
      try {
        const sendProductView = () => {
          if (
            typeof nitro !== 'undefined' &&
            typeof nitro.productView === 'function'
          ) {
            const data = {
              title: ecomProductData?.display_name,
              image: ecomProductData?.thumbnail_image,
              page_url: currentUrl,
              product_id: ecomProductData?.id,
              product_category: landingPageData?.categories?.[0]?.name,
              product_type: ecomProductData?.category?.toLocaleLowerCase(),
              country: zebra_selected_country?.name,
              currency: ecomProductData?.i18n_attributes?.currency,
              utm_data: utmData,
            }
            nitro.productView(data);

          } else {
            console.warn('Nitro SDK not loaded');
          }
        };

        // Fire immediately if Nitro SDK is already ready
        if (
          typeof nitro !== 'undefined' &&
          typeof nitro.productView === 'function'
        ) {
          sendProductView();
        } else {
          // SDK not ready yet — chain into nitroSettings.ready so we don't miss the callback
          (window as any).nitroSettings = (window as any).nitroSettings || {};
          const existingReady = (window as any).nitroSettings.ready;

          (window as any).nitroSettings.ready = function (...args: any[]) {
            if (typeof existingReady === 'function') {
              existingReady.apply(this, args);
            }
            sendProductView();
          };
        }
      } catch (error) {
        console.error('Nitro Product View Error:', error);
      }
    };

    run();
  }, [ecomProductData?.id])



  // Product Schema
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: metaData?.title || 'Default Product Name',
    brand: {
      '@type': 'Brand',
      name: 'ZebraLearn',
    },
    image: metaData?.image || 'https://zebralearn.com/logo.png',
    description: metaData?.description,
    category: 'Books',
    review: metaData?.reviews?.length
      ? metaData.reviews.map((r: any) => ({
        '@type': 'Review',
        author: { '@type': 'Person', name: r?.user?.name ?? 'zebralearn' },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: r?.rating ?? 4,
          bestRating: 5,
        },
        reviewBody: r.text,
      }))
      : undefined,
    aggregateRating:
      metaData?.reviews?.length && metaData.reviews.length > 0
        ? {
          '@type': 'AggregateRating',
          ratingValue: (
            metaData.reviews.reduce(
              (sum: number, r: any) => sum + (r?.rating ?? 4),
              0,
            ) / metaData.reviews.length
          ).toFixed(1),
          reviewCount: metaData.reviews.length,
          bestRating: Math.max(
            ...(metaData.reviews.map((r: any) => r?.rating ?? 4) || [5]),
          ),
        }
        : undefined,
  };



  // details_view Events
  useEffect(() => {
    if (!userData) return;
    EventV2({
      payload: {
        event_name: 'details_view',
        source: 'books',
        source_type: landingPageData?.bookType,
        source_id: landingPageData?.form?.readersProductId,
        source_name: ecomProductData?.display_name,
        unit: 'boolean',
        value: 1,
        meta: {
          product_category: landingPageData?.categories?.[0]?.name,
          book_total_pages: landingPageData?.form?.numberOfPages
        }
      },
      userData: userData,
      pathname: router.pathname
    })
  }, [userData])

  // details_session event — tracks active seconds, fires automatically when user leaves
  useSessionTracking({
    enabled: !!userData,
    userData,
    payload: {
      event_name: 'details_session',
      source: 'books',
      source_type: landingPageData?.bookType,
      source_id: landingPageData?.form?.readersProductId,
      source_name: ecomProductData?.display_name,
      meta: {
        product_category: landingPageData?.categories?.[0]?.name,
        book_total_pages: landingPageData?.form?.numberOfPages
      }
    }
  })

  const claimSoftButton = (
    <ButtonDefault
      disabled={purchasedData?.softProduct?.purchased || keyCount === 0}
      variant={ButtonVariants.PRIMARY}
      is3D
      size={0}
      className='w-full px-3 py-[9px]'
      onClick={() =>
        bookLandingDetails && claimHandle(bookLandingDetails?.digitalProductId)
      }
    >
      <p className='text-sm leading-[22px] font-semibold text-white '>
        Claim Digital Copy with 1
      </p>
      <WhiteKeyIcon />
    </ButtonDefault>
  );

  const claimHardButton = (
    hardCopyCountryData?.is_available ?
      <ButtonDefault
        disabled={
          purchasedData?.hardProduct?.purchased ||
          keyCount === 0 ||
          bookLandingDetails?.hardCoverAvailable === false
        }
        size={0}
        variant={ButtonVariants.PRIMARY}
        is3D
        className='w-full px-3 py-[9px] disabled:bg-black'
        onClick={() =>
          bookLandingDetails &&
          claimHandle(bookLandingDetails?.hardCoverProductId)
        }
      >
        <p className='text-sm leading-[22px] font-semibold text-white '>
          Claim Hard Copy with 1
        </p>
        <WhiteKeyIcon />
      </ButtonDefault> : <></>
  );

  const startReadingHandler = ({
    bookId,
    chapterId,
    chapterPageNumber,
    bookType,
  }: {
    bookId: string;
    chapterId?: string;
    chapterPageNumber?: number;
    bookType?: string;
  }) => {
    let url = `/pdf/${bookId}`;
    const params = new URLSearchParams();

    if (chapterId !== undefined) {
      params.append('chapterId', chapterId);
      if (chapterPageNumber !== undefined) {
        params.append('chapterPageNumber', chapterPageNumber?.toString());
      }
    } else if (chapterPageNumber !== undefined) {
      params.append('chapterPageNumber', chapterPageNumber?.toString());
    }

    if (bookType === 'short') {
      params.append('samplePdf', 'true');
    }

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    router.push(url);
  };

  const productAccessEnrollHandle = async () => {
    if (
      productAccessCheckData?.can_access &&
      !productAccessCheckData.is_purchased &&
      !productAccessCheckData.user_product &&
      bookLandingDetails?.digitalProductId
    ) {
      try {
        await productAccessEnroll(
          bookLandingDetails?.digitalProductId?.toString(),
        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  const renderCTASection = () => {
    const bookType = bookLandingDetails?.bookType;
    const isShort = bookType === 'short';
    const isComingSoon = bookType === 'comingSoon';
    const isLong = !isShort && !isComingSoon;

    const claimWithGemsButton = (
      <>
        {isSubscriptionActive(userData) ? (
          <div className='mt-2.5'>
            {userData?.subscription?.snapshot?.rules?.[0]?.physical ? (
              claimHardButton
            ) : userData?.subscription?.snapshot?.rules?.[0]?.digital ? (
              purchasedData.softProduct.purchased ? (
                React.cloneElement(claimSoftButton, {
                  onClick: () => {
                    notify('Already Purchased', 'info');
                  },
                  disabled: false,
                  className: clsx(
                    claimSoftButton.props.className,
                    'shadow-none opacity-30 bg-[radial-gradient(50%_150%_at_46.7%_0%,#7f7f7f_0%,_#7f7f7f_100%)]',
                  ),
                })
              ) : keyCount ? (
                claimSoftButton
              ) : (
                React.cloneElement(claimSoftButton, {
                  onClick: () => {
                    notify('Insufficient Credit', 'info');
                  },
                  disabled: false,
                  className: clsx(
                    claimSoftButton.props.className,
                    'shadow-none opacity-30 bg-[radial-gradient(50%_150%_at_46.7%_0%,#7f7f7f_0%,_#7f7f7f_100%)]',
                  ),
                })
              )
            ) : (
              <></>
            )}
          </div>
        ) : null}

        <ShouldRender
          check={
            !isSubscriptionActive(userData) && hasPreviouslySubscribed(userData)
          }
        >
          {React.cloneElement(claimHardButton, {
            disabled: false,
            className: twMerge(
              claimHardButton.props.className,
              'mt-2.5',
            ),
          })}
        </ShouldRender>
      </>
    );

    switch (true) {
      // case isPurchased:
      //   return (
      //     <div className='flex gap-2 w-full'>
      //       <ButtonDefault
      //         size={4}
      //         rounded={false}
      //         roundedSm={true}
      //         onClick={() => {
      //           router.push(
      //             `/pdf/${slidBookContainerData?.readersProductId}?chapterPageNumber=${lastPageRead || 1}`,
      //           );
      //         }}
      //         variant={ButtonVariants.WHITE}
      //         className='flex w-full justify-center px-5 py-3 border-none font-medium text-xs whitespace-nowrap'
      //       >
      //         <span className='px-4 text-sm md:text-base font-semibold py-1'>
      //           {lastPageRead === null || +lastPageRead === 1
      //             ? 'Start'
      //             : 'Continue'}{' '}
      //           Reading
      //         </span>
      //       </ButtonDefault>
      //     </div>
      //   );
      case isShort:
        return (
          <div className='flex gap-2 w-full'>
            <ButtonDefault
              size={4}
              rounded={false}
              roundedSm={true}
              onClick={() => {
                if (token) {
                  router.push(
                    `/pdf/${slidBookContainerData?.readersProductId}?samplePdf=true`,
                  );
                } else {
                  setVisible((prevState) => ({
                    ...prevState,
                    signUp: true,
                    bookId: slidBookContainerData?.readersProductId as string,
                  }));
                }
              }}
              variant={ButtonVariants.WHITE}
              className='flex w-full justify-center px-5 py-3 border-none font-medium text-xs whitespace-nowrap'
            >
              <span className='px-4 text-sm md:text-base font-semibold py-1'>
                Start Reading
              </span>
            </ButtonDefault>
          </div>
        );

      case isComingSoon:
        return (
          <div className='flex flex-col w-full justify-center'>
            <ButtonDefault
              isWidthFull={true}
              size={4}
              variant={
                isPreOrderAvailable
                  ? ButtonVariants.PRIMARY
                  : ButtonVariants.UNSTYLED
              }
              is3D={isPreOrderAvailable}
              unavailableText='Pre-Order'
              available={isPreOrderAvailable}
              loading={loadingAddToCart.value}
              disabled={loadingAddToCart.value}
              onClick={(e) => {
                e.stopPropagation();
                handleAddDataToCart(
                  {
                    id: Number(heroSectionData?.hardCoverProductId) as number,
                    temp_user_id: localUserId,
                    quantity: 1,
                    isBuyNow: true,
                    trackingData: {
                      productData: {
                        price: Number(
                          heroSectionData?.hardCopyPrice?.discountedPrice,
                        ),
                        id: Number(heroSectionData?.hardCoverProductId),
                        heading: `${ecomProductData?.display_name}`,
                        quantity: 1 as number,
                        currency: hardCopyCountryData?.i18n_attributes?.currency,
                        category: landingPageData?.categories?.[0]?.name,
                      },
                      userData,
                      pathname: router.pathname,
                      productType: 'hardcopy',
                      type: 'books',
                    },
                  },
                  'hardCopy',
                  true,
                );
              }}
              className='w-full p-0 py-0 px-0'
            >
              <div className='w-full flex justify-center font-semibold leading-6 items-center gap-1 py-[3px] px-3.5'>
                Pre-Order at {hardCopyCountryData?.currency_symbol}
                {hardCopyCountryData?.preorder_display_price}
              </div>
            </ButtonDefault>
            {claimWithGemsButton}
          </div>
        );

      case isLong:
      default: {
        if (isOrgMember) {
          return (
            <div className='flex flex-col w-full gap-2.5'>
              {/* Corporate Option Cards matching normal pricing button styles */}
              <div className='grid grid-cols-2 gap-2.5 w-full'>
                {/* Hardcopy + Digital Card - Primary Highlighted */}
                <div className='relative min-w-[151px] flex flex-1 rounded-lg h-full'>
                  <ButtonDefault
                    size={0}
                    isWidthFull={true}
                    rounded={false}
                    roundedSm={true}
                    variant={ButtonVariants.WHITE}
                    className='px-[7px] py-2 min-h-[66px] w-full'
                    onClick={(e) => {
                      e.stopPropagation();
                      const hardId =
                        ecomProductData?.id ||
                        bookLandingDetails?.hardCoverProductId ||
                        4531;
                      router.push(`/corporate-checkout?productId=${hardId}`);
                    }}
                  >
                    <div className='active:scale-95 transition-transform cursor-pointer relative w-full flex flex-col gap-1 rounded-lg'>
                      <div className='flex items-center gap-2.5 justify-center'>
                        <p className={clsx(montserrat.className, 'text-sm font-semibold text-black text-center line-clamp-1')}>
                          Hardcopy + Digital
                        </p>
                      </div>
                      <div className='flex items-center gap-1 justify-center'>
                        <p className={clsx(montserrat.className, 'text-center text-base/6 font-semibold text-black whitespace-nowrap')}>
                          ₹{hardCorporatePrice.unit_price}
                        </p>
                        <p className={clsx(montserrat.className, 'text-center text-sm/6 font-medium text-grayZl-700 line-through whitespace-nowrap')}>
                          ₹{hardCorporatePrice.regular_price}
                        </p>
                      </div>
                    </div>
                  </ButtonDefault>
                </div>

                {/* Digital Copy Card */}
                <div className='relative min-w-[151px] flex flex-1 rounded-lg h-full'>
                  <ButtonDefault
                    size={0}
                    isWidthFull={true}
                    rounded={false}
                    roundedSm={true}
                    variant={ButtonVariants.GRAY}
                    className='px-[7px] py-2 min-h-[66px] w-full'
                    onClick={(e) => {
                      e.stopPropagation();
                      const digitalId =
                        ecomProductData?.digital_pair?.id ||
                        bookLandingDetails?.digitalProductId ||
                        4530;
                      router.push(`/corporate-checkout?productId=${digitalId}`);
                    }}
                  >
                    <div className='active:scale-95 transition-transform cursor-pointer relative w-full flex flex-col gap-1 rounded-lg'>
                      <div className='flex items-center gap-2.5 justify-center'>
                        <p className={clsx(montserrat.className, 'text-sm font-semibold text-white text-center line-clamp-1')}>
                          Digital Copy
                        </p>
                      </div>
                      <div className='flex items-center gap-1 justify-center'>
                        <p className={clsx(montserrat.className, 'text-center text-base/6 font-semibold text-white whitespace-nowrap')}>
                          ₹{digitalCorporatePrice.unit_price}
                        </p>
                        <p className={clsx(montserrat.className, 'text-center text-sm/6 font-medium text-grayZl-700 line-through whitespace-nowrap')}>
                          ₹{digitalCorporatePrice.regular_price}
                        </p>
                      </div>
                    </div>
                  </ButtonDefault>
                </div>
              </div>

              {/* EXCLUSIVE BUSINESS PRICE Banner */}
              <div className='w-full relative flex items-center justify-center mt-2'>
                <div
                  className='w-full py-2 px-6 flex items-center justify-center relative overflow-hidden'
                  style={{
                    background:
                      'linear-gradient(90deg, #000000 0%, #150400 12%, #380E01 32%, #7A2102 55%, #C23A05 78%, #FF5612 100%)',
                    clipPath: 'polygon(0 0, calc(100% - 7px) 0, calc(100% - 39px) 100%, 0 100%)',
                  }}
                >
                  <span
                    className={clsx(
                      montserrat.className,
                      'text-xs sm:text-sm font-medium tracking-wider uppercase italic text-white drop-shadow-sm select-none',
                    )}
                  >
                    EXCLUSIVE BUSINESS PRICE
                  </span>
                </div>
                {/* Slanted Accent Stripe */}
                <div
                  className='absolute inset-0 pointer-events-none'
                  style={{
                    background: '#FF5612',
                    clipPath:
                      'polygon(calc(100% - 3px) 0, 100% 0, calc(100% - 32px) 100%, calc(100% - 35px) 100%)',
                  }}
                />
              </div>

              {claimWithGemsButton}
            </div>
          );
        }

        const hasDigitalPair = Boolean(ecomProductData?.digital_pair);
        const hasUpgradeOffer = Boolean(
          ecomProductData?.upgrade_offer &&
          (ecomProductData.upgrade_offer.eligible === undefined ||
            ecomProductData.upgrade_offer.eligible === true),
        );
        const digitalId = Number(
          ecomProductData?.digital_pair?.id ||
            bookLandingDetails?.digitalProductId,
        );
        const effectiveDigitalCopyData =
          digitalCopyCountryData && digitalCopyCountryData.is_available !== null
            ? digitalCopyCountryData
            : ecomProductData?.digital_pair
            ? {
                stroked_price: formatPrice(ecomProductData.digital_pair.stroked_price),
                main_price: formatPrice(ecomProductData.digital_pair.main_price),
                currency_symbol: ecomProductData.digital_pair.currency_symbol || '₹',
                is_available:
                  (ecomProductData.digital_pair.is_available &&
                    ecomProductData.digital_pair.i18n_attributes) ||
                  ecomProductData.digital_pair.is_available ||
                  null,
                i18n_attributes: ecomProductData.digital_pair.i18n_attributes,
              }
            : digitalCopyCountryData;

        return (
          <>
            {/* Start */}
            <div className='flex flex-col w-full'>
              <div
                className={twMerge(
                  'grid grid-cols-2 gap-2.5 w-full',
                  (!hasDigitalPair || hasUpgradeOffer) ? 'grid-cols-1' : '',
                )}
              >
                <ShouldRender check={hasUpgradeOffer}>
                  <div className='relative w-full flex flex-1 rounded-lg h-full'>
                    <ButtonDefault
                      size={0}
                      isWidthFull={true}
                      rounded={false}
                      roundedSm={true}
                      variant={ButtonVariants.WHITE}
                      enableScaling={false}
                      onClick={(e) => {
                        e.stopPropagation();
                        const hardId =
                          ecomProductData?.id ||
                          bookLandingDetails?.hardCoverProductId;
                        router.push({
                          pathname: '/checkout/upgrad-to-hardcopy',
                          query: { productId: hardId },
                        });
                      }}
                      className='px-3 py-2 w-full border-none'
                    >
                      <div className='active:scale-95 transition-transform cursor-pointer relative flex-1 flex flex-col gap-1 bg-white rounded-lg'>
                        <div className='flex items-center justify-center gap-2.5 '>
                          <p className='text-sm text-center font-semibold text-black line-clamp-1'>
                            Upgrade to Hardcopy
                          </p>
                        </div>
                        <div className='flex items-center gap-1 justify-center'>
                          <p className='text-base/6 font-semibold text-black'>
                            {hardCopyCountryData?.currency_symbol || '₹'}
                            {ecomProductData?.upgrade_offer?.upgrade_price || 1000}
                          </p>
                          {hardCopyCountryData?.stroked_price ? (
                            <p className='text-sm/6 font-medium text-grayZl-700 line-through'>
                              {hardCopyCountryData?.currency_symbol || '₹'}{' '}
                              {hardCopyCountryData?.stroked_price}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </ButtonDefault>
                  </div>
                </ShouldRender>

                <ShouldRender check={!hasUpgradeOffer}>
                  <div className='relative min-w-[151px] flex flex-1 rounded-lg h-full'>
                    {/* Hard Copy Button */}
                    <ShouldRender
                      check={bookLandingDetails?.hardCoverAvailable !== false}
                    >
                      <ButtonDefault
                        size={0}
                        isWidthFull={true}
                        rounded={false}
                        roundedSm={true}
                        variant={
                          hardCopyCountryData?.is_available !== null
                            ? ButtonVariants.WHITE
                            : ButtonVariants.UNSTYLED
                        }
                        available={hardCopyCountryData?.is_available !== null}
                        enableScaling={false}
                        loading={
                          Number(bookLandingDetails?.hardCoverProductId) ===
                          loadingAddToCart.id && loadingAddToCart.value
                        }
                        disabled={
                          Number(bookLandingDetails?.hardCoverProductId) ===
                          loadingAddToCart.id && loadingAddToCart.value
                        }
                        unavailableText='Hard Copy'
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddDataToCart(
                            {
                              id: Number(
                                bookLandingDetails?.hardCoverProductId,
                              ) as number,
                              temp_user_id: localUserId,
                              quantity: 1,
                              trackingData: {
                                productData: {
                                  price: Number(
                                    bookLandingDetails?.hardCopyPrice
                                      ?.discountedPrice,
                                  ),
                                  id: Number(bookLandingDetails?.hardCoverProductId),
                                  heading: ecomProductData?.display_name as string,
                                  quantity: 1 as number,
                                  currency:
                                    hardCopyCountryData?.i18n_attributes?.currency,
                                  category: landingPageData?.categories?.[0]?.name,
                                },
                                userData,
                                pathname: router.pathname,
                                productType: 'hardcopy',
                                type: 'books',
                              },
                            },
                            'hardCopy',
                          );
                        }}
                        className={clsx(
                          hasDigitalPair &&
                            effectiveDigitalCopyData?.is_available !== null &&
                            'border-none',
                          'px-3 py-2',
                        )}
                      >
                        <div className='active:scale-95 transition-transform cursor-pointer relative flex-1 flex flex-col gap-1 bg-white rounded-lg'>
                          <div className='flex items-center justify-center gap-2.5 '>
                            <p className='text-sm text-center font-semibold text-black line-clamp-1'>
                              Hardcopy{' '}
                              <ShouldRender
                                check={
                                  hasDigitalPair &&
                                  hardCopyCountryData?.is_available !== null
                                }
                              >
                                {' '}
                                + Digital
                              </ShouldRender>
                            </p>
                          </div>
                          <div className='flex items-center gap-1 justify-center'>
                            <p className='text-base/6 font-semibold text-black'>
                              {hardCopyCountryData?.currency_symbol}
                              {hardCopyCountryData?.main_price}
                            </p>
                            <p className='text-sm/6 font-medium text-grayZl-700 line-through'>
                              {hardCopyCountryData?.currency_symbol}{' '}
                              {hardCopyCountryData?.stroked_price}
                            </p>
                          </div>
                        </div>
                      </ButtonDefault>
                    </ShouldRender>

                    {/* Avaiable Soon */}
                    <ShouldRender
                      check={bookLandingDetails?.hardCoverAvailable === false}
                    >
                      <div className='w-full bg-black rounded-lg border-[1.5px] border-grayZl-850 h-full flex flex-col items-center justify-center'>
                        <p className='text-xs/5 font-semibold text-center'>
                          Hard Copy
                        </p>
                        <p className='text-xs/5 font-medium  text-transparent bg-[linear-gradient(180deg,#F9742C_0%,#F20486_100%)] bg-clip-text'>
                          Available Soon
                        </p>
                      </div>
                    </ShouldRender>
                  </div>
                </ShouldRender>

                {/* Soft Copy Button */}
                <ShouldRender check={hasDigitalPair && !hasUpgradeOffer}>
                  <ButtonDefault
                    size={0}
                    isWidthFull={true}
                    rounded={false}
                    roundedSm={true}
                    variant={
                      effectiveDigitalCopyData?.is_available !== null
                        ? ButtonVariants.GRAY
                        : ButtonVariants.UNSTYLED
                    }
                    available={effectiveDigitalCopyData?.is_available !== null}
                    enableScaling={false}
                    loading={
                      Number(digitalId) ===
                      loadingAddToCart.id && loadingAddToCart.value
                    }
                    disabled={
                      Number(digitalId) ===
                      loadingAddToCart.id && loadingAddToCart.value
                    }
                    unavailableText='Digital Copy'
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isPlatformSubscriptionActive(userData)) {
                        if (productAccessCheckData?.can_access) {
                          startReadingHandler({
                            bookId:
                              bookLandingDetails?.readersProductId as string,
                            chapterPageNumber: lastPageRead || undefined,
                          });
                          productAccessEnrollHandle();
                        }
                        // else {
                        //   showModal();
                        // }
                        return;
                      }
                      handleAddDataToCart(
                        {
                          id: Number(digitalId) as number,
                          temp_user_id: localUserId,
                          quantity: 1,
                          trackingData: {
                            productData: {
                              price: Number(
                                effectiveDigitalCopyData?.main_price ||
                                  bookLandingDetails?.softCopyPrice?.discountedPrice,
                              ),
                              id: Number(digitalId),
                              heading: (ecomProductData?.digital_pair?.display_name ||
                                ecomProductData?.digital_pair?.name ||
                                ecomProductData?.display_name) as string,
                              quantity: 1 as number,
                              currency:
                                effectiveDigitalCopyData?.currency_symbol ||
                                hardCopyCountryData?.i18n_attributes?.currency,
                            },
                            userData,
                            pathname: router.pathname,
                            productType: 'digitalcopy',
                            type: 'books',
                          },
                        },
                        'digitalCopy',
                      );
                    }}
                    className={clsx(
                      effectiveDigitalCopyData?.is_available !== null &&
                        'border-none',
                      'min-h-[66px]  px-3 py-2',
                    )}
                  >
                    <div className='active:scale-95 transition-transform flex-1 flex flex-col gap-1 rounded-lg'>
                      <div className='flex items-center justify-center gap-2.5'>
                        <p className='text-sm text-center font-semibold text-white'>
                          Digital Copy
                        </p>
                      </div>
                      {isPlatformSubscriptionActive(userData) ? (
                        <p className='text-xs/5 font-medium text-success-500 whitespace-nowrap text-center'>
                          Subscribed • Read Now
                        </p>
                      ) : (
                        <div className='flex items-center gap-1 justify-center'>
                          <p className='text-base/6 font-semibold text-white'>
                            {effectiveDigitalCopyData?.currency_symbol}
                            {effectiveDigitalCopyData?.main_price}
                          </p>
                          <p className='text-sm/6 font-medium text-grayZl-700 line-through'>
                            {effectiveDigitalCopyData?.currency_symbol}{' '}
                            {effectiveDigitalCopyData?.stroked_price}
                          </p>
                        </div>
                      )}
                    </div>
                  </ButtonDefault>
                </ShouldRender>
              </div>
              {claimWithGemsButton}
            </div>
            {/* End */}
          </>
        );
      }
    }
  };

  return (
    <>
      <Head>
        <title key='title'>
          {metaData?.title || 'Book Details - ZebraLearn'}
        </title>
        <meta
          name='description'
          content={
            metaData?.description || 'Explore our latest books at ZebraLearn.'
          }
          key='description'
        />
        <meta
          name='keywords'
          content={metaData?.keywords || 'books, learning, education'}
          key='keywords'
        />
        <meta
          name='author'
          content={metaData?.author || 'ZebraLearn'}
          key='author'
        />

        <meta
          property='og:title'
          content={
            metaData?.openGraph?.title || metaData?.title || 'ZebraLearn'
          }
          key='og-title'
        />
        <meta
          property='og:description'
          content={
            metaData?.openGraph?.description || metaData?.description || ''
          }
          key='og-description'
        />
        <meta
          property='og:image'
          content={
            metaData?.openGraph?.image ||
            'https://zebralearn-store.s3.ap-south-1.amazonaws.com/thubnail-creative.png'
          }
          key='og-image'
        />

        <meta
          property='og:image:type'
          content='image/png'
          key='og-image-type-png'
        />
        {/* Twitter Metadata (Overrides Global) */}
        <meta
          name='twitter:title'
          content={
            metaData?.openGraph?.title || metaData?.title || 'ZebraLearn'
          }
          key='twitter-title'
        />
        <meta
          name='twitter:description'
          content={
            metaData?.openGraph?.description || metaData?.description || ''
          }
          key='twitter-description'
        />
        <meta
          name='twitter:image'
          content={
            metaData?.openGraph?.image ||
            'https://zebralearn-store.s3.ap-south-1.amazonaws.com/OG+1.png?tr=f-png'
          }
          key='twitter-image'
        />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
        <meta
          property='article:section'
          content='Website Section'
          key='article-section'
        />
        <meta
          property='article:tag'
          content={metaData?.keywords as string}
          key='article-tag'
        />
        <link
          rel='canonical'
          href={removeTrailingSlash(
            metaData?.canonicalUrl ?? (canonicalUrlPageUrl as string),
          )}
          key='canonical'
        />
      </Head>

      <Script
        id='product-schema'
        type='application/ld+json'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <ShouldRender
        check={!loading && bookLandingDetails && swp?.toString() !== 'false'}
      >
        <div className=' relative w-full '>
          <ShouldRender
            check={
              bookLandingDetails?.bookType === 'comingSoon' &&
              (getGlobalCountry()?.name?.toLowerCase() === 'india' ||
                isPreOrderAvailable)
            }
          >
            <div className='w-full fixed top-[55px] lg:top-[60px] left-0 bg-gradient-to-r from-black via-[#1a1a1a] to-[#444] text-white text-sm z-30'>
              <div className='max-w-[1240px] mx-auto flex justify-center items-center py-3 md:py-[18px]'>
                <span className='opacity-80 hidden md:inline-block'>
                  Pre-order offer
                </span>
                <span className='opacity-80'>
                  <span className='hidden md:inline-block px-2'>|</span>
                  Get Hard + Digital Book at{' '}
                  <span className='text-[#FF5B00] font-medium'>
                    {' '}
                    {hardCopyCountryData?.currency_symbol}
                    {hardCopyCountryData?.preorder_display_price}
                  </span>{' '}
                  only
                </span>
              </div>
            </div>
          </ShouldRender>
          <div
            className={clsx(
              bookLandingDetails?.bookType !== 'comingSoon' ? ' ' : '',
              ' relative flex h-full ',
            )}
          >
            <div className='w-full pb-20 md:pb-24 lg:pb-5'>
              <Section direction='left'>
                <div>
                  <ShouldRender check={!screens.lg}>
                    <Section>
                      <div className='h-full z-40'>
                        <SlidBookContainer
                          ecomProductData={ecomProductData}
                          productAccessCheckData={productAccessCheckData}
                          bookLandingDetails={bookLandingDetails}
                          purchasedData={purchasedData}
                          slidBookContainerData={
                            slidBookContainerData as ISlidBook
                          }
                          token={token}
                          digitalCopyCountryData={digitalCopyCountryData}
                          hardCopyCountryData={hardCopyCountryData}
                          isPurchased={isPurchased as boolean}
                          lastPageRead={lastPageRead as number}
                          landingPageData={landingPageData}
                        />
                      </div>
                    </Section>
                  </ShouldRender>
                  <div className=' bg-bgColor lg:bg-transparent md:py-4 lg:py-[56px] px-4  md:px-10 xl:px-20 relative overflow-hidden'>
                    <div className='absolute customGradient inset-0 hidden md:block   translate-y-2 backdrop-blur-xl -z-10'></div>
                    <div className='absolute inset-0 hidden lg:block  bg-[#000000CC]  -z-20'></div>

                    <div className='absolute inset-0 hidden lg:block  w-full h-full -z-30'>
                      <Image
                        src={heroSectionData?.bookImage as string}
                        alt='Background Image'
                        layout='fill'
                        priority
                        className='rotate-90    transform w-full h-auto absolute -translate-y-10 2xl:-translate-y-24 top-0 left-0'
                      />
                    </div>

                    <ShouldRender check={!loading && heroSectionData}>
                      <div className='z-40 '>
                        <HeroSection
                          landingPageData={landingPageData}
                          ecomProductData={ecomProductData}
                          authorsData={
                            authorsData as IAuthorInterface | IAuthorInterface[]
                          }
                          heroSectionData={
                            heroSectionData as IHeroSectionLandingPage
                          }
                          digitalCopyCountryData={digitalCopyCountryData}
                          hardCopyCountryData={hardCopyCountryData}
                        />
                      </div>
                    </ShouldRender>
                  </div>

                  <div className='lg:w-1/2 xl:w-2/3 pt-[56px] pb-[20px] md:py-[56px] px-5 md:px-10 lg:pl-10 lg:pr-0 xl:px-20 text-white flex flex-col gap-y-[56px]'>
                    <BookDescription
                      description={
                        bookDescriptionData?.bookDescription as string[]
                      }
                      whatYouWillLearn={
                        bookDescriptionData?.whatYouWillLearn as string[]
                      }
                    />
                    <ShouldRender check={!short}>
                      <ShouldRender
                        check={bookLandingDetails?.bookType !== 'comingSoon'}
                      >
                        <IframeLandingPage
                          data={iframeData as IIframeLandingPage}
                        />
                        <Banner />
                        <RecommendedAndOverViewSection
                          recommendedAndOverViewSectionData={
                            recommendedAndOverViewSectionData as IRecommendedAndOverViewSection
                          }
                        />
                      </ShouldRender>
                    </ShouldRender>

                    <CurriculumSection
                      data={
                        curriculumLandingPageData as ICurriculumLandingPageData
                      }
                    />

                    <SneakPeekSection
                      data={sneakPeekData?.sneakPeek as string[]}
                    />
                    <AuthorDetailsSection
                      landingPageData={landingPageData}
                      data={
                        authorDetailsData as
                        | IAuthorDetails
                        | IAuthorDetailsList[]
                      }
                      authorsData={authorsData}
                      isMultipleAuthors={
                        heroSectionData?.isMultipleAuthors || false
                      }
                      productId={bookDetails?._id || ''}
                      productName={bookDetails?.bookName || ''}
                    />

                    <ReviewsLandingPage
                      isLoggedIn={!!token}
                      digitalCoverId={
                        bookLandingDetails?.digitalProductId?.toString() as string
                      }
                      hardCoverId={
                        bookLandingDetails?.hardCoverProductId?.toString() as string
                      }
                      isComingSoon={
                        bookLandingDetails?.bookType === 'comingSoon'
                      }
                      isPurchased={isPurchased}
                    />

                    <RecommendedBooksSection
                      category={
                        bookLandingDetails?.categories?.[0]?.name ?? undefined
                      }
                      categoryId={
                        bookLandingDetails?.categories?.[0]?.categoryId
                      }
                      token={token}
                      type={
                        bookLandingDetails?.bookType === 'comingSoon'
                          ? 'comingSoon'
                          : 'book'
                      }
                    />
                  </div>
                </div>
              </Section>
            </div>
            <ShouldRender check={screens?.lg}>
              <AnimatePresence mode='wait'>
                <div className='absolute right-20 2xl:right-[8%] top-[8px]'>
                  <Affix offsetTop={offset}>
                    <Section direction='right'>
                      <div className='slid-book-container transition-all duration-300 ease-in-out'>
                        <SlidBookContainer
                          ecomProductData={ecomProductData}
                          productAccessCheckData={productAccessCheckData}
                          bookLandingDetails={bookLandingDetails}
                          purchasedData={purchasedData}
                          slidBookContainerData={
                            slidBookContainerData as ISlidBook
                          }
                          token={token}
                          digitalCopyCountryData={digitalCopyCountryData}
                          hardCopyCountryData={hardCopyCountryData}
                          isPurchased={isPurchased}
                          lastPageRead={lastPageRead as number}
                          landingPageData={landingPageData}
                        />
                      </div>
                    </Section>
                  </Affix>
                </div>
              </AnimatePresence>
            </ShouldRender>

            <ShouldRender check={!screens.lg}>
              <div
                className={clsx(
                  !screens.lg && 'fixed bottom-0 left-0 z-40',
                  'w-full',
                )}
              >
                <div className='bg-black border-t border-grayZl-850 px-4 xxs:px-4 md:px-10 lg:px-0 pt-5 pb-3 backdrop-blur-sm flex gap-x-2.5 xxs:gap-x-2.5 relative z-40'>
                  {renderCTASection()}
                </div>
              </div>
            </ShouldRender>
          </div>
        </div>
      </ShouldRender>

      <ShouldRender check={swp?.toString() === 'false'}>
        <Section>
          <div id='products' className={` flex items-center w-full `}>
            <ShouldRender check={!loading}>
              <Products productData={bookDetails} token={token} />
            </ShouldRender>
          </div>
        </Section>
      </ShouldRender>

      <ShouldRender check={loading}>
        <CustomLoader />
      </ShouldRender>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async ({
  query,
  resolvedUrl,
  req,
}) => {
  try {
    const { bookId } = query;
    const parts = (bookId as string).split('-');

    const rawCookies = req.headers.cookie || '';
    const parsedCookies = cookie.parse(rawCookies);

    const token = parsedCookies['auth_token']?.trim();

    const metaData = await getLandingPageSeoSSR(parts[parts.length - 1] || '');
    const landingPageData = await getBookLandingPageDataSSR(bookId as string);

    let country = parsedCookies['country']?.trim();

    if (!country) {
      const [activeCountries, detectedCode] = await Promise.all([
        getActiveCountries(),
        detectCountry(req),
      ]);

      if (activeCountries.length > 0) {
        const fallback = activeCountries.find((c: any) => c.code === 'IN');
        const found =
          activeCountries.find((c: any) => c.code === detectedCode) || fallback;

        country = found?.code || 'IN';
      }
    }

    let hardCopy = null;
    let digitalCopy = null;
    let ecomProductData = null;
    if (landingPageData?.form?.hardCoverProductId) {
      const productData = await getProductDataSSR(
        landingPageData?.form?.hardCoverProductId,
        country as string,
        token,
      );

      ecomProductData = productData;

      if (productData) {
        hardCopy = {
          stroked_price: formatPrice(productData?.stroked_price),
          main_price: formatPrice(productData?.main_price),
          currency_symbol: productData?.currency_symbol,
          is_available:
            (productData?.is_available && productData?.i18n_attributes) || null,
          is_preorder: productData?.is_preorder,
          i18n_attributes: productData?.i18n_attributes,
          preorder_price: productData?.preorder_price || null,
          preorder_display_price: productData?.preorder_display_price || null,
          preorder_coupon_code: productData?.preorder_coupon_code || null,
        };

        if (productData?.digital_pair) {
          digitalCopy = {
            stroked_price: formatPrice(
              productData?.digital_pair?.stroked_price,
            ),
            main_price: formatPrice(productData?.digital_pair?.main_price),
            currency_symbol: productData?.digital_pair?.currency_symbol,
            is_available:
              (productData?.digital_pair?.is_available &&
                productData?.digital_pair?.i18n_attributes) ||
              null,
            is_preorder: productData?.digital_pair?.is_preorder,
            i18n_attributes: productData?.digital_pair?.i18n_attributes,
            preorder_price: productData?.digital_pair?.preorder_price || null,
          };
        }
      }
    } else {
      console.warn('⚠️ No hardCoverProductId found in landingPageData.form');
    }

    let isPurchased = null;
    let lastPageRead = 1;
    if (token) {
      try {
        const bookPageData = await getBooDataByIdSSR(
          parts.slice(-1)[0] as string,
          token as string,
        );
        isPurchased = bookPageData?.isPurchased || false;
        lastPageRead = bookPageData?.pageRead?.pageNumber || null;
      } catch (error) {
        isPurchased = false;
      }
    }

    const formattedMetaData = {
      title: metaData?.title || '',
      description: metaData?.description || '',
      image:
        generateUrlForImage(
          `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
          `${Endpoints.getCoverImagesForBooks}/`,
          `${metaData?._id}`,
        ) || '',
      author: landingPageData?.form?.authorName || '',
      keywords: metaData?.keywords || '',
      openGraph: {
        title: metaData?.openGraph?.title ?? null,
        description: metaData?.openGraph?.description ?? null,
        image: metaData?.openGraph?.image ?? null,
      },
      categories: landingPageData?.form?.categories ?? null,
      slug: landingPageData?.form?.categories?.slug ?? null,
      canonicalUrl: metaData?.canonicalUrl ?? null,
      price: landingPageData?.form?.hardCopyPrice?.discountedPrice ?? null,
      reviews: metaData?.reviews ?? [],
      ratingValue: landingPageData?.form?.rating ?? null,
      reviewCount: metaData?.reviews?.length ?? 0,
    };
    const canonicalUrlPageUrl = `https://zebralearn.com${resolvedUrl.split('?')[0]}`;

    let productAccessCheckData = null;
    if (token && landingPageData?.form?.digitalProductId) {
      try {
        const result = await productAccessCheckSSR(
          landingPageData.form.digitalProductId,
          token,
        );
        productAccessCheckData = result.data;
      } catch (error) {
        console.warn('Initial product access check failed:', error);
      }
    }

    return {
      props: {
        metaData: formattedMetaData,
        canonicalUrlPageUrl,
        digitalCopyCountryData: digitalCopy,
        hardCopyCountryData: hardCopy,
        isPurchased,
        lastPageRead,
        productAccessCheckData,
        landingPageData,
        ecomProductData,
      },
    };
  } catch (error: any) {
    if (error?.code === 404 || error?.message?.includes('404')) {
      return {
        redirect: {
          destination: '/',
          permanent: false,
        },
      };
    }

    return {
      props: {
        metaData: null,
        canonicalUrlPageUrl: 'https://zebralearn.com/',
        digitalCopyCountryData: null,
        hardCopyCountryData: null,
        isPurchased: false,
        lastPageRead: 1,
        productAccessCheckData: null,
        landingPageData: null,
        ecomProductData: null,
      },
    };
  }
};

export default BookDetailsPage;
